import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import HomeTwo from "./pages/home-2";
import HomeThree from "./pages/home-3";
import HomeFour from "./pages/home-4";
import About from "./pages/about";
import Team from "./pages/team";
import TeamDetails from "./pages/team-details";
import Testimonials from "./pages/testimonials";
import Faq from "./pages/faq";
import NoPage from "./pages/NoPage";
import Services from "./pages/services";
import Careers from "./pages/careers";
// import Peak from "./pages/peak-performance-roofing";
// import Skyline from "./pages/skyline-roofing-solutions";
// import Sure from "./pages/sure-guard-roofing-services";
// import Reliable from "./pages/reliable-roof-repair";
import Restoration from "./pages/top-notch-roofing-restoration";
import Project from "./pages/project";
import ProjectDetails from "./pages/project-details";
import Blog from "./pages/blog";
import Bloglist from "./pages/blog-list";
import BlogDetails from "./pages/blog-details";
import Contact from "./pages/contact";
import Peak from "./pages/network-security";
import Skyline from "./pages/ot-iot-security";
import Sure from "./pages/cloud-security";
import Reliable from "./pages/api-security";
import Vulnerable from "./pages/vulnerability-assessment";
import Designimplementation from "./pages/design-&-implementation";
import Manageditservice from "./pages/managed-it-services";
import Offensivesecurityredteaming from "./pages/offensive-security-red-teaming";
import Networkoperationscenter from "./pages/network-operations-center";
import Securityoperationscenter from "./pages/security-operations-center";
import Securityconsulting from "./pages/security-consulting";
import Auditcompliance from "./pages/audit-&-compliance";
import Cs from "./pages/cyber-security";
import MetaTitle from "./components/metaTitle";
import NewsEvents from "./pages/NewsEvents"




export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<HomeTwo />} />
        <Route path="*" element={<NoPage />} />
        <Route path="home-2" element={<HomeTwo />} />
        <Route path="home-3" element={<HomeThree />} />
        <Route path="home-4" element={<HomeFour />} />
        <Route path="about" element={<About />} />
        <Route path="team" element={<Team />} />
        <Route path="team-details" element={<TeamDetails />} />
        <Route path="testimonials" element={<Testimonials />} />
        <Route path="faq" element={<Faq />} />
        <Route path="services" element={<Services />} />
        <Route path="careers" element={<Careers/>} />
        <Route path="peak-performance-roofing" element={<Peak />} />
        <Route path="skyline-roofing-solutions" element={<Skyline />} />
        <Route path="sure-guard-roofing-services" element={<Sure />} />
        <Route path="reliable-roof-repair" element={<Reliable />} />
        <Route path="top-notch-roofing-restoration" element={<Restoration />} />
        <Route path="project" element={<Project />} />
        <Route path="project-details" element={<ProjectDetails />} />
        <Route path="blog" element={<Blog />} />
        <Route path="blog-list" element={<Bloglist />} />
        <Route path="blog-details" element={<BlogDetails />} />
        <Route path="contact" element={<Contact />} />
        <Route path="network-security" element={<Peak />} />
        <Route path="ot-iot-security" element={<Skyline />} />
        <Route path="cloud-security" element={<Sure />} />
        <Route path="api-security" element={<Reliable />} />
        <Route path="vulnerability-assessment" element={<Vulnerable />} />
        <Route path="design-&-implementation" element={<Designimplementation   />} />
        <Route path="managed-it-services" element={<Manageditservice   />} />
        <Route path="offensive-security-red-teaming" element={<Offensivesecurityredteaming   />} />
        <Route path="network-operations-center" element={<Networkoperationscenter   />} />
        <Route path="security-operations-center" element={<Securityoperationscenter   />} />
        <Route path="security-consulting" element={<Securityconsulting   />} />
        <Route path="audit-&-compliance" element={<Auditcompliance />} />
        <Route path="cyber-security" element={<Cs/>} />
        <Route path="/about" element={<MetaTitle/>} />
        <Route path="/news-events" element={<NewsEvents/>} />
      </Routes>
    </BrowserRouter>
  );
}
